// Card quick-add: mobile tap-to-open panel + real add-to-cart on a length
// pill, dispatching the theme's actual CartLinesUpdateEvent so cart-drawer.js
// (auto-open) and cart-icon.js (bubble count) react exactly as they do for
// the native product form — see assets/cart-drawer.js #handleCartLinesUpdate.
import { CartLinesUpdateEvent } from '@shopify/events';

document.addEventListener('click', (event) => {
  const colourSwatch = event.target.closest('[data-card-color-swatch]');
  if (colourSwatch) {
    event.preventDefault();
    const card = colourSwatch.closest('.ag-card');
    if (!card) return;

    card.querySelectorAll('[data-card-color-swatch]').forEach((swatch) => {
      const isSelected = swatch === colourSwatch;
      swatch.classList.toggle('is-selected', isSelected);
      swatch.setAttribute('aria-pressed', String(isSelected));
    });

    const variantUrl = colourSwatch.dataset.cardUrl;
    if (variantUrl) {
      card.querySelectorAll('.ag-card__link, .ag-card__title').forEach((link) => {
        link.href = variantUrl;
      });
    }

    const imageUrl = colourSwatch.dataset.cardImage;
    const mainImage = card.querySelector('.ag-card__img--main');
    if (imageUrl && mainImage) {
      mainImage.removeAttribute('srcset');
      mainImage.src = imageUrl;
      mainImage.alt = colourSwatch.dataset.cardImageAlt || mainImage.alt;
    }
    return;
  }

  const openBtn = event.target.closest('[data-quick-add-open]');
  if (openBtn) {
    const card = openBtn.closest('.ag-card');
    card?.classList.toggle('is-quick-open');
    return;
  }

  // Tapping outside a card closes any open quick-add panel (mobile).
  if (!event.target.closest('.ag-card__quick, [data-quick-add-open]')) {
    document.querySelectorAll('.ag-card.is-quick-open').forEach((c) => c.classList.remove('is-quick-open'));
  }

  const sizeBtn = event.target.closest('.ag-card__size');
  if (!sizeBtn || sizeBtn.classList.contains('is-unavailable')) return;

  const variantId = sizeBtn.dataset.variantId;
  if (!variantId) return;

  const titleEl = sizeBtn.closest('.ag-card__quick')?.querySelector('[data-quick-title]');
  const originalTitle = titleEl?.textContent;
  sizeBtn.disabled = true;

  const deferred = CartLinesUpdateEvent.createPromise();
  document.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'quick-add',
      lines: [{ merchandiseId: variantId, quantity: 1 }],
      promise: deferred.promise,
    })
  );

  const cartItemsComp = document.querySelector('cart-items-component');
  const sectionId = cartItemsComp?.dataset?.sectionId || 'cart-drawer-section';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({
      items: [{ id: variantId, quantity: 1 }],
      sections: sectionId,
    }),
  })
    .then((res) => res.json())
    .then((addResponse) => {
      if (addResponse.status) throw new Error(addResponse.message || 'Add to cart failed');
      // Open and fill the drawer from this response. A second /cart.js
      // round-trip was holding the drawer shut until the count came back.
      deferred.resolve({
        cart: undefined,
        detail: {
          didError: false,
          items: undefined,
          sections: addResponse.sections || {},
          source: 'quick-add',
          itemCount: undefined,
        },
      });
      if (titleEl) titleEl.textContent = `Added ${sizeBtn.textContent.trim()}″ ✓`;
      setTimeout(() => {
        if (titleEl && originalTitle) titleEl.textContent = originalTitle;
        sizeBtn.closest('.ag-card')?.classList.remove('is-quick-open');
      }, 1800);
      fetch('/cart.js')
        .then((r) => r.json())
        .then((cartJson) => {
          if (!cartJson || cartJson.item_count == null) return;
          document.dispatchEvent(new CustomEvent('ag:cart-updated', { detail: { count: cartJson.item_count } }));
          const cartIcon = document.querySelector('cart-icon');
          if (cartIcon && typeof cartIcon.renderCartBubble === 'function') {
            cartIcon.renderCartBubble(cartJson.item_count, false);
          }
        })
        .catch(() => {});
    })
    .catch((err) => {
      deferred.reject(err);
      if (titleEl) titleEl.textContent = 'Couldn’t add — try again';
    })
    .finally(() => {
      sizeBtn.disabled = false;
    });
});
